type TDAYS_OF_WEEK_ISO = {
  [key: string]: number;
};

const DAYS_OF_WEEK_ISO: TDAYS_OF_WEEK_ISO = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export default DAYS_OF_WEEK_ISO;
